import React, { Fragment, useState, useEffect, useRef, useContext } from "react";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { useParams, useLocation } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datetime/css/react-datetime.css";
import { toast, Slide } from "react-toastify";
import records from "../../../Services/records";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import SweetAlert from 'react-bootstrap-sweetalert';
import Portal from "../../../Utils/portals";
import { appContext } from "../../../Utils/context";
import avatar1 from '../../../assets/utils/images/user.png'
import {
    Input,
    Row,
    Col,
    Card,
    CardBody,
    CardHeader,
    CardTitle,
    Button,
    FormGroup, ListGroup, ListGroupItem,
    Label,
    Spinner,
    Modal, ModalBody
} from "reactstrap";

export default function RightSide({ newTags, setNewTags, uatId, setList, list, tasks, setTasks }) {
    const { user } = useContext(appContext)
    const [show, setShow] = useState(false)
    const [check, setCheck] = useState(false)
    const [count, setCount] = useState(0)
    const [t, setT] = useState("min")
    const [data, setData] = useState({ uat_id: uatId, task_type: "Task", reminder_source: "Email", frequency: "once" })
    const [btn, setBtn] = useState("Create Task")
    const [isLoading, setIsLoading] = useState(false)
    const [alert, setAlert] = useState(false)
    const [specificId, setSpecificId] = useState(null)
    const [deleteRequesting, setDeleteRequesting] = useState(false)
    const [ajaxRequesting, setAjaxRequesting] = useState(false)
    const [startDate, setStartDate] = useState(null)
    const [followChange, setFollowChange] = useState(false)
    const [index,setIndex] = useState(false)

    const par = useParams()
    const location = useLocation()
    const taskId = new URLSearchParams(location.search).get('taskId')

    const bottomRef = useRef(null);

    const state1 = {
        uat_id: uatId,
        status_type: "all",

    }
    const handleChange = (v, k) => { setData(prevData => ({ ...prevData, [k]: v })); }

    useEffect(() => {
        if (par?.id && taskId !== null) {
            setTimeout(() => {
                bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
            }, 2000)

        }
    }, [])


    const tempChange=(temp)=>{
        if (temp !== " ") {
            if(uatId !== undefined && uatId !== null){
                    setDeleteRequesting(true)
                    const data ={
                        temperature_status: temp
                    }
                    records
                    .addNewTags(uatId.toString(), data).then((res) => {
                        setNewTags(res.data)
                        const updatedList = list.map((object) => {
                            if (object.uat_id === uatId) {
                              return { ...object, temperature_status: res.data.temperature_status };
                            }
                            return object;
                          });
                          setList(updatedList)

                        notify22(`Property Tempertaure Updated to ${res.data?.temperature_status} `, "success")
        
                    }).catch((err) => {
                        console.log("erroriz ", err)
                    }).finally(() => setDeleteRequesting(false))
                }
                else{
                    setNewTags({...newTags,temperature_status:`${temp}` })
                        
                        notify22(`Property Tempertaure Updated to ${temp} `, "success")
        
                }}
    }

    const sortByActionTime = (data) => {
        return [...data].sort((a, b) => {
            return new Date(a.action_time) - new Date(b.action_time);
        });
    };

    const addFollowDate = () => {
        if(uatId !== undefined && uatId !== null){
        if (followChange) {
            const dateObject = new Date(newTags?.follow_up_date);
            const year = dateObject.getUTCFullYear();
            const month = String(dateObject.getUTCMonth() + 1).padStart(2, '0');
            const day = String(dateObject.getUTCDate()).padStart(2, '0');
            const hours = String(dateObject.getUTCHours()).padStart(2, '0');
            const minutes = String(dateObject.getUTCMinutes()).padStart(2, '0');
            const seconds = String(dateObject.getUTCSeconds()).padStart(2, '0');
            const offsetHours = dateObject.getTimezoneOffset() / 60;

            const formattedDateString = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${offsetHours >= 0 ? '+' : '-'}${Math.abs(offsetHours).toString().padStart(2, '0')}:00`;
            const data ={
                follow_up_date: formattedDateString
            }
            records
            .addNewTags(uatId.toString(), data).then((res) => {
                  notify22("Follow-UP-Date Updated", "success")
                setFollowChange(false)
                setNewTags(res.data)
                const updatedList = list.map((object) => {
                    if (object.uat_id === uatId) {
                      return { ...object, follow_up_date: res?.data?.follow_up_date };
                    }
                    return object;
                  });
                  setList(updatedList)
            }).catch((err) => {
                console.log("erroriz ", err.response.data.message)
            })
        }}
        else{
            notify22("Follow-UP-Date Updated", "success")
        }
    }

    const clearFollowDate = () => {
        if(uatId !== undefined && uatId !== null){
        const data ={
            follow_up_date: null
        }
        records
        .addNewTags(uatId.toString(), data).then((res) => {
            notify22("Follow-UP-Date Cleared", "success")
            setNewTags(res.data)
                const updatedList = list.map((object) => {
                    if (object.uat_id === uatId) {
                      return { ...object, follow_up_date: res?.data?.follow_up_date };
                    }
                    return object;
                  });
                  setList(updatedList)


        }).catch((err) => {
            console.log("erroriz ", err.response.data.message)
        })}
        else{
            setNewTags({...newTags,follow_up_date:null })
            notify22("Follow-UP-Date Cleared", "success")
        }

    }

    const addTask = () => {
        setAjaxRequesting(true)
        btn === "Create Task" && (() => {
            if(uatId !== undefined && uatId !== null){
            records.addTask(data).then((res) => {
                setTasks(sortByActionTime(res?.data))
                setShow(!show)
                setData({ uat_id: uatId, task_type: "Task", reminder_source: "Email", frequency: "once" })
                setCount(0)
                setCheck(false)
                setT("min")
                setStartDate(null)
                notify22("Task Added", "success")
                const updatedList = list.map((object) => {
                    if (object.uat_id === uatId) {
                        const lastTask = res.data[res.data.length - 1];
                        return { ...object, last_task: lastTask };
                      }
                    return object;
                  });
                  setList(updatedList)
            }).catch((err) => {
                err?.response?.data?.task_name && (
                    notify22("Task Name is Required", "error")
                )
                err?.response?.data?.action_time && (
                    notify22("Action date is Required", "error")
                )

                err?.response?.data?.description && (
                    notify22("Description has no more than 100 characters", "error")
                )
                //notify22(err?.response?.data[0], "error")
                console.log("error isx", err)
            }
            ).finally(() => setAjaxRequesting(false))}
            else{
                if (!data?.task_name){
                    notify22("Task Name is Required", "error")
                    setAjaxRequesting(false)
                }
                else if (!data?.action_time){
                    notify22("Action date is Required", "error")
                    setAjaxRequesting(false)
                }
                else if (!data?.description){
                    notify22("Description has no more than 100 characters", "error")
                    setAjaxRequesting(false)
                }else{
                setTasks([...tasks,{...data}])
                setShow(!show)
                setCount(0)
                setCheck(false)
                setT("min")
                setStartDate(null)
                setAjaxRequesting(false)}
            }
    })();
        btn === "Edit Task" && (() => {
            if(uatId !== undefined && uatId !== null){
            records.updateTask(data).then((res) => {
                setTasks(sortByActionTime(res?.data))
                setShow(!show)
                setBtn("Create Task")
                setData({ uat_id: uatId, task_type: "Task", reminder_source: "Email", frequency: "once" })
                setCount(0)
                setCheck(false)
                setT("min")
                setStartDate(null)
                const updatedList = list.map((object) => {
                    if (object.uat_id === uatId) {
                        const lastTask = res.data[res.data.length - 1];
                        return { ...object, last_task: lastTask };
                      }
                    return object;
                  });
                  setList(updatedList)
                notify22("Task Updated", "success")
            }).catch((err) => {
                err?.response?.data?.task_name && (
                    notify22("Task Name is Required", "error")
                )
                err?.response?.data?.action_time && (
                    notify22("Action date is Required", "error")
                )

                err?.response?.data?.description && (
                    notify22("Description has no more than 100 characters", "error")
                )
                //notify22(err?.response?.data[0], "error")
                console.log("error isx", err)
            }).finally(() => setAjaxRequesting(false))}
        else{
            if (!data?.task_name){
                notify22("Task Name is Required", "error")
                setAjaxRequesting(false)
            }
            else if (!data?.action_time){
                notify22("Action date is Required", "error")
                setAjaxRequesting(false)
            }
            else if (!data?.description){
                notify22("Description has no more than 100 characters", "error")
                setAjaxRequesting(false)
            }else{
            const newData = [...tasks]
            newData[index] = data;
            setTasks(newData)
                setShow(!show)
                setCount(0)
                setIndex(false)
                setCheck(false)
                setT("min")
                setStartDate(null)
                setAjaxRequesting(false)}
        }
        }           
        )();
    }

    useEffect(() => {
        handleChange((t === "min" ? count : count * 60), "pre_reminder_time")
    }, [count])


    const deleteTask = () => {
        setDeleteRequesting(true)
        if(uatId !== undefined && uatId !== null){
        records.deleteTask({ uat_id: uatId, task_id: specificId }).then((res) => {
            setTasks(sortByActionTime(res?.data))
            setAlert(false)
            const updatedList = list.map((object) => {
                if (object.uat_id === uatId) {
                    const lastTask = res.data[res.data.length - 1];
                    return { ...object, last_task: lastTask };
                  }
                return object;
              });
              setList(updatedList)
            notify22("Task Deleted", "success")
        }).catch((err) => console.log("err", err))
            .finally(() => setDeleteRequesting(false))}
            else{
                const newData = tasks.filter((item, index) => index !== specificId);
                setTasks(newData)
                setAlert(false)
            notify22("Task Deleted", "success")
            setDeleteRequesting(false)
            setSpecificId(null)
            }
    }

    const editTask = (v) => {
        const { action_time, ...newV } = v
        setBtn("Edit Task")
        setData({ ...newV, task_id: v?.id })
        setStartDate(new Date(v?.action_time.slice(0, 16)))
        setCount(v?.pre_reminder_time <= 60 ? v?.pre_reminder_time : v?.pre_reminder_time / 60)
        v?.frequency === "once" ? setCheck(false) : setCheck(true)
        handleStartDate(new Date(v?.action_time.slice(0, 16)))
        setShow(!show)

        v?.pre_reminder_time <= 60 ? setT("min") : setT("hour")

    }


    const notify22 = (msg, type) =>
        toast(msg, {
            transition: Slide,
            autoClose: 5000,
            position: "top-right",
            type: type,

        });


    const toggleShow = () => {
        setShow(!show)
        setBtn("Create Task")
        setData({ uat_id: uatId, task_type: "Task", reminder_source: "Email", frequency: "once" })
        setCount(0)
        setCheck(false)
        setT("min")
        setStartDate(null)
    }

    const handleStartDate = (date) => {
        const inputDate = new Date(date);

        const outputDate = new Date(inputDate.getTime() - (inputDate.getTimezoneOffset() * 60000));

        const formattedDateString = outputDate.toISOString().replace('Z', '');
        const formattedDateString1 = formattedDateString.replace('T', ' ')
        handleChange(formattedDateString1, "action_time")

    }

    function convertToAMPM(timeString) {
        // Split the time string into hours and minutes
        const [hours, minutes] = timeString.split(':').map(Number);

        // Determine AM or PM
        const period = hours >= 12 ? 'PM' : 'AM';

        // Convert 24-hour format to 12-hour format
        const hours12 = hours % 12 || 12; // 0 should be treated as 12 in 12-hour format

        // Create the AM/PM time string
        const ampmTime = `${hours12}:${String(minutes).padStart(2, '0')} ${period}`;

        return ampmTime;
    }

    const handleFollowDate = (e) => {
        setNewTags({...newTags,follow_up_date:e})
      };

    return (
        <Fragment>
            <TransitionGroup>
                <CSSTransition component="div" classNames="TabsAnimation" appear={true}
                    timeout={0} enter={false} exit={false}>
                    <div>
                        <Row>
                            <Col md="12"  >
                                <Card className="main-card mb-1">
                                    <CardBody className="pb-1">
                                        <CardTitle>
                                            Property TEMPERATURE

                                        </CardTitle>
                                        <Row className="g-1" >
                                            <Col role="button" xs="2" className="btn-hover-shine border rounded-start border-end-0 border-secondary text-center d-flex justify-content-center align-items-center"
                                                style={newTags?.temperature_status === 'none' ? { backgroundColor: '#A9A9A9', color: "white", fontWeight: "bold" } : { backgroundColor: '#f8f9fa' }}
                                                onClick={() =>{ tempChange("none")}}>{(deleteRequesting && newTags?.temperature_status === 'none') ? <Spinner size="sm" /> : "None"}</Col>
                                            <Col role="button" xs="2" className="btn-hover-shine border border-end-0 border-secondary text-center d-flex justify-content-center align-items-center"
                                                style={newTags?.temperature_status === 'cold' ? { backgroundColor: '#87CEEB', color: "white", fontWeight: "bold" } : { backgroundColor: '#f8f9fa' }}
                                                onClick={() =>{ tempChange("cold")}}>{(deleteRequesting && newTags?.temperature_status === 'cold') ? <Spinner size="sm" /> : "Cold"}</Col>
                                            <Col role="button" xs="2" className="btn-hover-shine border border-end-0 border-secondary text-center d-flex justify-content-center align-items-center"
                                                style={newTags?.temperature_status === 'warm' ? { backgroundColor: '#E37383', color: "white", fontWeight: "bold" } : { backgroundColor: '#f8f9fa' }}
                                                onClick={() =>{ tempChange("warm")}}>{(deleteRequesting && newTags?.temperature_status === 'warm') ? <Spinner size="sm" /> : "Warm"}</Col>
                                            <Col role="button" xs="2" className="btn-hover-shine border border-end-0 border-secondary  d-flex justify-content-center align-items-center"
                                                style={newTags?.temperature_status === 'hot' ? { backgroundColor: '#A80000', color: "white", fontWeight: "bold" } : { backgroundColor: '#f8f9fa' }}
                                                onClick={() =>{ tempChange("hot")}}>{(deleteRequesting && newTags?.temperature_status === 'hot') ? <Spinner size="sm" /> : "Hot"}</Col>
                                            <Col role="button" xs="4" className="btn-hover-shine lh-sm border rounded-end border-secondary text-center"
                                                style={newTags?.temperature_status === 'Under Contract' ? { backgroundColor: '#228B22', color: "white", fontWeight: "bold" } : { backgroundColor: '#f8f9fa' }}
                                                onClick={() =>{ tempChange("Under Contract")}}>{(deleteRequesting && newTags?.temperature_status === 'Under Contract') ? <Spinner size="sm" className="m-2" /> : "Under Contract"}</Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>

                            <Col md="12"  >
                                <Card className="main-card mb-1">
                                    <CardBody className="pb-1">
                                        <CardTitle>
                                            FOLLOW UP
                                        </CardTitle>
                                        <Row className="g-1">
                                            <Col xs="11">
                                                <DatePicker withPortal minDate={new Date()} selected={newTags?.follow_up_date && new Date(newTags?.follow_up_date)}
                                                   onChange={(date) => {handleFollowDate(date); setFollowChange(true) }} 
                                                    showTimeSelect className="form-control"
                                                    timeIntervals={5} 
                                                    dateFormat="MM-dd-yyyy'-'HH:mm aa"
                                                    placeholderText="Follow Up Date & Time"
                                                    onCalendarClose={addFollowDate} />
                                            </Col>
                                            <Col xs="1">
                                                <Button className="border-0 btn-transition mt-1" outline color="danger" title=" Delete" onClick={clearFollowDate}>
                                                    <FontAwesomeIcon icon={faTrashAlt} size="1x" />
                                                </Button>
                                            </Col>

                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>

                            <Col md="12"  >
                                <Card className="main-card mb-1 ">
                                    <CardBody className="pb-1" >

                                        <Row className="mb-2">
                                            <Col xs="7">
                                                <h4>TASKS ({tasks.length})</h4>
                                            </Col>
                                            <Col xs="5">
                                                <Button block outline className=" btn-wide mb-1 btn-transition" color="primary" onClick={toggleShow} >
                                                    + Task
                                                </Button>
                                            </Col>
                                        </Row>
                                        {isLoading ? (

                                            <SkeletonTheme highlightColor="#E0E0E0">



                                                <Row className="mb-2" >

                                                    <Col xs="4" className="mt-1">
                                                        <Skeleton width={70} height={15} />
                                                    </Col>
                                                    <Col xs="4"></Col>
                                                    <Col xs="4">


                                                    </Col>
                                                    <Col xs="12">
                                                        <Skeleton count={4} width={230} height={20} />
                                                    </Col>
                                                </Row>


                                            </SkeletonTheme>

                                        ) : (
                                            <Row>
                                                {tasks?.map((v, k) => (
                                                    <Col md="12" className="mb-1" key={k} >
                                                        {/* new code here */}
                                                        <Card className="main-card" style={{ boxShadow: (par?.id && taskId == v?.id) ? '0 0 10px 8px #aaaaaa' : '' }}>

                                                            <CardBody className="pb-1">
                                                                <CardTitle>
                                                                    {
                                                                        (par?.id && taskId === v?.id) && (
                                                                            <Row>
                                                                                <Col>
                                                                                    <div ref={bottomRef} />
                                                                                </Col>
                                                                            </Row>

                                                                        )

                                                                    }
                                                                    <Row className="g-0">
                                                                        <Col xs="8">
                                                                            <span className="text-primary fw-bold me-2 mt-2">{k + 1}-</span> {v?.task_name}
                                                                        </Col>
                                                                        <Col xs="4">
                                                                            <Button className="border-0 btn-transition" outline color="primary" title=" Edit" onClick={() => {(uatId !== undefined && uatId !== null)? editTask(v) : editTask(v);setIndex(k)}}>
                                                                                <FontAwesomeIcon icon={faPen} size="1x" />
                                                                            </Button>
                                                                            <Button className="border-0 btn-transition" outline color="danger" title=" Delete" onClick={() => { setAlert(true); (uatId !== undefined && uatId !== null)? setSpecificId(v?.id) :setSpecificId(k) }}>
                                                                                <FontAwesomeIcon icon={faTrashAlt} size="1x" />
                                                                            </Button>
                                                                        </Col>
                                                                    </Row>

                                                                </CardTitle>
                                                                <ListGroup flush>
                                                                    <ListGroupItem>
                                                                        <div className="widget-content p-0">
                                                                            <div className="widget-content-wrapper">
                                                                                <div className="widget-content-left">
                                                                                    <div className="widget-heading">
                                                                                        Description
                                                                                    </div>
                                                                                </div>
                                                                                <div className="widget-content-right">
                                                                                    <div className="text-secondary">
                                                                                        {v?.description?.substring(0, 100) || "None"}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </ListGroupItem>
                                                                    <ListGroupItem>
                                                                        <div className="widget-content p-0">
                                                                            <div className="widget-content-wrapper">
                                                                                <div className="widget-content-left">
                                                                                    <div className="widget-heading">
                                                                                        Date
                                                                                    </div>
                                                                                </div>
                                                                                <div className="widget-content-right">
                                                                                    <div className="fw-bold text-secondary">
                                                                                        {/* {new Date(v?.action_time)?.toString()?.slice(0, 15)} */}
                                                                                        {v?.action_time?.slice(0, 10)}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </ListGroupItem>
                                                                    <ListGroupItem>
                                                                        <div className="widget-content p-0">
                                                                            <div className="widget-content-wrapper">
                                                                                <div className="widget-content-left">
                                                                                    <div className="widget-heading">
                                                                                        Time
                                                                                    </div>
                                                                                </div>
                                                                                <div className="widget-content-right">
                                                                                    <div className="fw-bold text-secondary">
                                                                                        {/* {new Date(v?.action_time)?.toString()?.slice(16, 21)} */}
                                                                                        {convertToAMPM(v?.action_time?.slice(11, 16))}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </ListGroupItem>

                                                                    <ListGroupItem>
                                                                        <div className="widget-content p-0">
                                                                            <div className="widget-content-wrapper">
                                                                                <div className="widget-content-left">
                                                                                    <div className="widget-heading">
                                                                                        Assigned
                                                                                    </div>
                                                                                </div>
                                                                                <div className="widget-content-right">
                                                                                    <div className="widget-heading ms-5">
                                                                                        <img width={30} className="rounded-circle" src={avatar1} alt="" role="button" title={user?.first_name + " " + user?.last_name} />
                                                                                    </div>
                                                                                    {/* <div className="widget-subheading opacity-8 text-info">
                                                                                        {user?.first_name} {user?.last_name}
                                                                                    </div> */}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </ListGroupItem>


                                                                </ListGroup>
                                                            </CardBody>
                                                        </Card>
                                                    </Col>
                                                )
                                                )}

                                            </Row>

                                        )}



                                    </CardBody>
                                </Card>
                            </Col>
                            {alert && (
                                <Portal id="sweet-alert-portal">
                                    <SweetAlert r title="Are you sure?" show={alert}
                                        type="danger" onConfirm={deleteTask} onCancel={() => setAlert(false)}
                                        showCancel confirmBtnText={deleteRequesting ? <><Spinner size="sm" /><span className="mb-2">{' '} Deleting</span> </>
                                            : "Yes, delete it!"} confirmBtnBsStyle="danger" cancelBtnBsStyle="info" />
                                </Portal>
                            )}
                        </Row>
                        <Modal isOpen={show} toggle={toggleShow} style={{ minWidth: "45%" }}>
                            <Card className="mb-2">
                                <CardHeader className="card-header-tab">
                                    <div className="card-header-title font-size-lg text-capitalize fw-normal">
                                        <i className="header-icon lnr-file-add icon-gradient bg-happy-green"> {" "} </i>
                                        <span className="menu-header-title text-capitalize">{btn}</span>
                                    </div>
                                </CardHeader>
                            </Card>
                            <ModalBody>
                                <Row className="g-0">
                                    <Col xs="3" className="mt-1" >
                                        <Label for="exampleEmail">Task Name:</Label>
                                    </Col>
                                    <Col xs="9" className="mb-2">
                                        <Input type="text" placeholder="Task" value={data?.task_name || ""} onChange={(e) => handleChange(e.target.value, "task_name")} />
                                    </Col>
                                    {/* <Col xs="3" className="mt-3" >
                                        <Label for="exampleEmail">Action Date</Label>
                                    </Col>
                                    <Col xs="9" className="mt-2 mb-2">
                                        <DatePicker placeholderText="Due Date" minDate={new Date()} className="form-control"
                                            selected={d} onChange={(e) => { setActionDate(dateFormatting(e)); setD(e); console.log("old date", e) }}
                                        />
                                    </Col> */}
                                    <Col xs="3" className="mt-4" >
                                        <Label for="exampleEmail">Description:</Label>
                                    </Col>
                                    <Col xs="9" className="mt-2 mb-2">
                                        <Input type="textarea" placeholder="Description" value={data?.description || ""} onChange={(e) => handleChange(e.target.value, "description")} />
                                    </Col>

                                    <Col xs="3" className="mt-3" >
                                        <Label for="exampleEmail">Action Date & Time:</Label>
                                    </Col>
                                    <Col xs="9" className="mt-2 mb-2">
                                        <DatePicker minDate={new Date()} selected={startDate} onChange={(date) => { setStartDate(date); handleStartDate(date) }} showTimeSelect className="form-control"
                                            timeIntervals={5} dateFormat="MMMM d yyyy h:mm aa"
                                            placeholderText="Date & Time" /> </Col>
                                    {/* 
                                    <Col xs="3" className="mt-4" >
                                        <Label for="exampleEmail">Action Time</Label>
                                    </Col>
                                    <Col xs="3" className="me-1 mt-3">
                                        <div className="input-group">

                                            <Button color="secondary" onClick={() => setHrs((prevhrs) => prevhrs > 0 ? prevhrs -= 1 : prevhrs = 24)}>-</Button>
                                            <Input type="text" disabled placeholder="hrs" value={hrs || ""} />
                                            <Button color="primary" onClick={() => setHrs((prevhrs) => prevhrs < 24 ? prevhrs += 1 : prevhrs = 0)} >+</Button>

                                        </div>
                                    </Col>

                                    <Col xs="3" className="me-1 mt-3">
                                        <div className="input-group">


                                            <Button color="secondary" onClick={() => setMins((prevMins) => prevMins > 0 ? prevMins -= 1 : prevMins = 60)}>-</Button>
                                            <Input type="text" disabled placeholder="mins" value={mins || ""} />
                                            <Button color="primary" onClick={() => setMins((prevMins) => prevMins < 60 ? prevMins += 1 : prevMins = 0)} >+</Button>

                                        </div>
                                    </Col> */}




                                    <Col xs="3" className="mt-4" >
                                        <Label for="exampleEmail">Recurring Task:</Label>
                                    </Col>
                                    <Col xs="4" className="mt-4">
                                        <FormGroup check>
                                            <Input type="checkbox" checked={check} onChange={(e) => { e.target.checked ? handleChange("monthly", "frequency") : handleChange("once", "frequency"); setCheck(e.target.checked); }} />
                                            <Label check>
                                                Recurrent Task
                                            </Label>
                                        </FormGroup>

                                    </Col>
                                    <Col xs="5" className="mt-3">
                                        {check && (

                                            <Input value={data?.frequency} type="select" onChange={(e) => handleChange(e.target.value, "frequency")}>
                                                <option value="monthly">Every Month</option>
                                                <option value="weekly">Every Week</option>
                                                <option value="daily">Every Day</option>
                                            </Input>

                                        )}
                                    </Col>

                                    <Col xs="3" className="mt-4" >
                                        <Label for="exampleEmail">Reminder:</Label>
                                    </Col>
                                    <Col xs="3" className="me-1 mt-3">


                                        <Input type="select" value={data?.reminder_source} onChange={(e) => handleChange(e.target.value, "reminder_source")} >
                                            <option>Email</option>
                                            <option>Sms</option>
                                        </Input>

                                    </Col>
                                    <Col xs="3" className="me-1 mt-3">
                                        <div className="input-group">

                                            <Button color="secondary" onClick={() =>
                                                t === "min" ?
                                                    setCount((prevCount) => prevCount > 0 ? prevCount -= 1 : prevCount = 60)

                                                    :
                                                    setCount((prevCount) => prevCount > 0 ? prevCount -= 1 : prevCount = 24)
                                            }>-</Button>
                                            <Input type="text" disabled placeholder="count" value={count} />
                                            <Button color="primary" onClick={() =>
                                                t === "min" ?
                                                    setCount((prevCount) => prevCount < 60 ? prevCount += 1 : prevCount = 0)
                                                    :
                                                    setCount((prevCount) => prevCount < 24 ? prevCount += 1 : prevCount = 0)
                                            } >+</Button>

                                        </div>
                                    </Col>
                                    <Col className="mt-3" >
                                        <Input type="select" value={t} onChange={(e) => { setT(e.target.value); setCount(0) }} >
                                            <option>min</option>
                                            <option>hour</option>
                                        </Input>
                                    </Col>

                                    <Col xs="3" className="mt-5" >
                                        <Label for="exampleEmail">Assigned:</Label>
                                    </Col>

                                    <Col xs="9" className="mt-4" >
                                        <div className="widget-content p-0">
                                            <div className="widget-content-wrapper">
                                                <div className="widget-content-left">
                                                    <div className="widget-heading ms-5">
                                                        <img width={35} className="rounded-circle" src={avatar1} alt="" role="button" title={user?.first_name + " " + user?.last_name} />
                                                    </div>
                                                    <div className="widget-subheading opacity-8 text-info">
                                                        {user?.first_name} {user?.last_name}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>


                                </Row>
                                <Row className="g-1 mt-4">
                                    <Col xs={2} sm={6}></Col>
                                    <Col xs={4} sm={3}>
                                        <Button block outline className=" btn-wide btn-transition" color="primary" onClick={addTask}>
                                            {ajaxRequesting ? <><Spinner size="sm" /><span>{' '} Saving</span> </>
                                                : "Save"}
                                        </Button>
                                    </Col>
                                    <Col xs={4} sm={3}>
                                        <Button block outline className=" btn-wide  btn-transition" color="secondary" onClick={toggleShow}>
                                            Cancel
                                        </Button>

                                    </Col>
                                    <Col xs={2} sm={0}></Col>

                                </Row>

                            </ModalBody>
                            {/* <ModalFooter>
                                        <Row >
                                            <Col xs="6" >
                                                <Button block outline className=" btn-wide btn-transition" color="primary" onClick={addTask}>
                                                    Save
                                                </Button>
                                            </Col>
                                            <Col xs="6">
                                                <Button block outline className=" btn-wide  btn-transition" color="secondary" onClick={toggleShow}>
                                                    Cancel
                                                </Button>
                                            </Col>
                                        </Row>
                                        
                                        
                                    </ModalFooter> */}
                        </Modal>
                    </div>
                </CSSTransition>
            </TransitionGroup>
        </Fragment>
    )



}